export default `
mutation wishlistShare($recipient_emails: [String!]!, $message: String, $sharing_code: String!, $item_comments: [WishlistItemCommentInput]) {
  wishlistShare(
    recipient_emails: $recipient_emails,
    message: $message,
    sharing_code: $sharing_code,
    item_comments: $item_comments
  ) {
    status
    message
  }
}
`
